import { EnhancedDistrictStats, EfficiencyRating, RiskLevel } from '../types/districts.types';

export const formatCurrency = (value: number): string => {
  if (!value) return '₹0';
  return new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(value);
};

export const formatNumber = (value: number): string => {
  if (!value) return '0';
  return new Intl.NumberFormat('en-IN').format(value);
};

export const formatPercentage = (value: number): string => {
  if (!value) return '0%';
  return `${value.toFixed(1)}%`;
};

export const safeParseFloat = (value: string | number | undefined): number => {
  if (value === undefined || value === '') return 0;
  const parsed = parseFloat(value.toString());
  return isNaN(parsed) ? 0 : parsed;
};

export const getPerformanceRating = (
  financialProgress: number,
  physicalProgress: number
): { rating: EfficiencyRating; color: string } => {
  const avgProgress = (financialProgress + physicalProgress) / 2;
  if (avgProgress >= 80) {
    return { rating: EfficiencyRating.Excellent, color: 'text-green-600' };
  } else if (avgProgress >= 60) {
    return { rating: EfficiencyRating.Good, color: 'text-blue-600' };
  } else if (avgProgress >= 40) {
    return { rating: EfficiencyRating.Average, color: 'text-yellow-600' };
  } else {
    return { rating: EfficiencyRating.Poor, color: 'text-red-600' };
  }
};

export const getRiskLevel = (
  delayedWorks: number,
  totalWorks: number,
  budgetUtilization: number
): RiskLevel => {
  const delayPercentage = totalWorks > 0 ? (delayedWorks / totalWorks) * 100 : 0;
  if (delayPercentage > 20 || budgetUtilization < 30) {
    return RiskLevel.High;
  } else if (delayPercentage > 10 || budgetUtilization < 50) {
    return RiskLevel.Medium;
  } else {
    return RiskLevel.Low;
  }
};

export const calculatePerformanceScore = (district: EnhancedDistrictStats): number => {
  const financialWeight = 0.4;
  const physicalWeight = 0.4;
  const delayWeight = 0.2;
  const financialScore = district.financial_progress_percentage || 0;
  const physicalScore = district.physical_progress_percentage || 0;
  const delayScore = district.total_works > 0 ? ((district.total_works - (district.delayed_works || 0)) / district.total_works) * 100 : 0;
  return Math.round(financialScore * financialWeight + physicalScore * physicalWeight + delayScore * delayWeight);
};